module.exports = __webpack_public_path__ + "static/img/yeswecan0030.fb4961f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0030.png
// module id = 596
// module chunks = 1